// extracted by mini-css-extract-plugin
module.exports = {"formLayout":"FormLayout_formLayout__4dHXQ","rotation":"FormLayout_rotation__NQGJZ"};